export enum TicketState {
    NEW = "NEW",
    IN_PROGRESS = "IN_PROGRESS",
    CLOSED = "CLOSED"
}
